import React from 'react';
import { Container, grey100, Row, Text } from '@paypalcorp/pp-react';
import { Message } from '@paypalcorp/worldready-react';
import { css, Global } from '@emotion/core';
import serverData from 'utils/server-data';
import ScrollToTop from '../Common/ScrollToTop';
import { Routes, useLocation, Route } from 'react-router';

const NotSupported = React.lazy(() => import('../Common/UnsupportedPage'));
const Landing = React.lazy(() => import('./Landing'));
const SignUp = React.lazy(() => import('./SignUp'));
const NewUserInfo = React.lazy(() => import('./NewUserInfo'));
const Upgrade = React.lazy(() => import('./Upgrade'));
const ConsumerUpgradeLanding = React.lazy(() =>
    import('./Upgrade/ConsumerUpgradeLanding')
);
const CollectMissingInfo = React.lazy(() =>
    import('./Upgrade/CollectMissingInfo')
);
const Declined = React.lazy(() => import('./DecisionPages/DeclinePage'));
const Review = React.lazy(() => import('./DecisionPages/RiskReview'));
const NeedMoreData = React.lazy(() => import('./DecisionPages/NeedMoreData'));
const DocUploadDone = React.lazy(() => import('./DecisionPages/DocUploadDone'));
const Approval = React.lazy(() => import('./DecisionPages/Approval'));

const base = css`
    padding-top: 1.5rem;
`;

const mobile = css`
    padding-top: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
`;

const formCSS = css`
    width: 100%;
    & > div {
        width: 23.5rem;
    }
    margin: 0 auto;
`;

// there are intentionally two kinds of page layout: one is for forms, like sign up page, net new user page, which
// consist of a set of fields and headers and labels. another is for the rest pages, which might have unique and
// specific styles.
// here we use an array to store the path of the latter to check whether the page has form style or not.
const antiFormStyleLinks = ['/entry', '/consumerUpgradeLanding'];

export default function USRoutes() {
    const location = useLocation();
    const checkStyle = !antiFormStyleLinks.some((link) =>
        location.pathname.includes(link)
    );

    const notSupported = serverData.unsupport;

    return (
        <>
            <Global />
            <Container
                data-testid="app-container"
                css={css`
                    ${serverData.isNativeWeb ? mobile : base}
                `}>
                <Row align="center" css={checkStyle && formCSS}>
                    <React.Suspense
                        fallback={
                            <Text>
                                <Message id="app.suspense.fallbackText" />
                            </Text>
                        }>
                        {/* make sure there is no same one in backend router for each path */}
                        {/* set primary as false to disable keeping position during transition */}
                        {/* if its an unsupported country, restrict them from onboarding */}
                        {notSupported ? (
                            <NotSupported />
                        ) : (
                            <div
                                style={
                                    serverData.isNativeWeb
                                        ? { width: '100%' }
                                        : {}
                                }>
                                <ScrollToTop location={location}>
                                    <Routes>
                                        <Route
                                            path="/signUp"
                                            element={<SignUp />}
                                        />
                                        <Route
                                            path="/entry"
                                            element={
                                                <Landing
                                                    mobile={
                                                        serverData.isNativeWeb
                                                    }
                                                />
                                            }
                                        />
                                        <Route
                                            path="/newUserInfo"
                                            element={<NewUserInfo />}
                                        />
                                        <Route
                                            path="/upgrade"
                                            element={<Upgrade />}
                                        />
                                        <Route
                                            path="/consumerUpgradeLanding"
                                            element={<ConsumerUpgradeLanding />}
                                        />
                                        <Route
                                            path="/declined"
                                            element={<Declined />}
                                        />
                                        <Route
                                            path="/additionalInfo"
                                            element={<NeedMoreData />}
                                        />
                                        <Route
                                            path="/review"
                                            element={<Review />}
                                        />
                                        <Route
                                            path="/collectMissingInfo"
                                            element={<CollectMissingInfo />}
                                        />
                                        <Route
                                            path="/docUploadDone"
                                            element={<DocUploadDone />}
                                        />
                                        <Route
                                            path="/approval"
                                            element={<Approval />}
                                        />
                                        <Route
                                            path="*"
                                            element={<NotSupported />}
                                        />
                                    </Routes>
                                </ScrollToTop>
                            </div>
                        )}
                    </React.Suspense>
                </Row>
            </Container>
        </>
    );
}
